import { Controller, SubmitHandler, useForm } from "react-hook-form";
import axiosInstance from "services/axiosInstance";
import * as S from "./styled";
/**
 * hooks
 */
import apiRequest from "../../../../hooks/apiRequest";
import useLoading from '../../../../hooks/useLoading';
import { useMultipleModal } from "../../../../hooks/useMultipleModal";
/**
 * Components
 */
import { useEffect, useState } from "react";
import LayoutModal from "../../../LayoutModal";
import Loading from "../../../Loading";
import ProgressBar from "../../../../components/ProgressBar";
import UpdateAdress from "../../../../components/Modals/Address/Update";
import CreateAdress from "../../../../components/Modals/Address/Create";
/**
 * Icons
 */
import { IMaskInput } from "react-imask";
/**
 * Interface
*/
import { Inputs, IAgreements } from "Interfaces/ICustomer";

interface ICreate {
  isOpenModalUpdate: boolean;
  setModalClose: () => void;
  selectedUrlId: number | null;
  updateList: () => void;
}

export default function Update({
  isOpenModalUpdate,
  setModalClose,
  updateList,
  selectedUrlId,
}: ICreate) {
  const {
    register,
    handleSubmit: handleFormSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm<Inputs>();

  const { isLoading, startLoading, stopLoading } = useLoading();
  const [material, setMaterial] = useState<IAgreements[]>([]);
  const { isOpenModal, toggleModalVisibility } = useMultipleModal();
  const [typeOpenModal, setTypeOpenModal] = useState('createAddress');
  const [addressId, setAddressId] = useState<number | null>(null);

  const fetchData = async () => {
    startLoading();
    try {
      const [response, responseAgree] = await Promise.all([
        axiosInstance.get(`customer/${selectedUrlId}`),
        axiosInstance.get('agreement')
      ]);

      const addressUrlId = response.data.address?.id;
      const dataResponse = responseAgree.data;
      setMaterial(dataResponse);

      if (addressUrlId) {
        setAddressId(addressUrlId);
        setTypeOpenModal('updateAddress');
      }
      const addressData = response.data;
      for (const key in addressData) {
        setValue(key as keyof Inputs, addressData[key]);
      }
    } catch (error) {
      console.log("Error: ", error);
    } finally {
      stopLoading();
    }
  };

  useEffect(() => {
    if (selectedUrlId !== null) {
      fetchData();
    }
  }, [selectedUrlId]);

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    startLoading();
    try {
      const response = await apiRequest(`customer/${selectedUrlId}`, 'PATCH', data);
      const status = response.status;
      if (status === 200) {
        alert("Cliente atualizado com sucesso!");
        toggleModalVisibility(typeOpenModal);
        updateList();
      }
    } catch (error: any) {
      alert(error.message || "Ocorreu um erro ao criar o usuário.");
    } finally {
      stopLoading();
    }
  };

  if (isOpenModalUpdate) {
    return (
      <LayoutModal
        statusLoad={isLoading}
        title="Atualizar Cliente"
        subTitle="Atualize informações do cliente em sua base de dados."
        setModalClose={setModalClose}
        submiteModal={handleFormSubmit(onSubmit)}
        nameSubmit="Próximo"

        nameIconMinimize={'Atualizar Cliente'}
        setMaximizeModal={fetchData}
      >

        {isLoading ? (
          <Loading />
        ) : (
          <S.Container>
            <S.ContentProgress>
              <ProgressBar name="Informações" active={true} />
              <ProgressBar name="Endereço" />
            </S.ContentProgress>
            <S.FormInput>
              <S.Label>
                Nome do Usuário
                <span>*</span>
              </S.Label>
              <S.Input
                placeholder="Informe o nome"
                type="text"
                {...register("full_name", { required: true })}
              />
              {errors.full_name && (
                <S.InforErro>Campo Obrigatório</S.InforErro>
              )}
            </S.FormInput>

            <S.SeparateDiv>
              <S.FormInput>
                <S.Label>CPF</S.Label>
                <Controller
                  name="cpf"
                  control={control}
                  render={({ field }) => (
                    <IMaskInput
                      className='imask'
                      id="cpf"
                      mask="000.000.000-00"
                      placeholder="000.000.000-00"
                      onAccept={(value: string) => field.onChange(value)}
                      {...field}
                    />
                  )}
                />
              </S.FormInput>

              <S.FormInput>
                <S.Label>RG</S.Label>
                <S.Input type="text" placeholder="0000000-0" />
              </S.FormInput>
            </S.SeparateDiv>

            <S.SeparateDiv>
              <S.FormInput className='inputLeft'>
                <S.Label>Data de Nascimento</S.Label>
                <S.Input
                  type="date"
                  placeholder="00/00/0000"
                  {...register('birth_date')} />
              </S.FormInput>

              <S.FormInput className='inputLeft'>
                <S.Label>Celular Principal</S.Label>
                <Controller
                  name="phone_primary"
                  control={control}
                  render={({ field }) => (
                    <IMaskInput
                      className='imask'
                      id="phone_primary"
                      mask="(00)00000-0000"
                      placeholder="(00) 00000-000"
                      {...field}
                    />
                  )}
                />
              </S.FormInput>
            </S.SeparateDiv>

            <S.FormInput>
              <S.Label>E-mail</S.Label>
              <S.Input
                placeholder="exemplo@gmail.com"
                type="email"
                {...register("email")}
              />
            </S.FormInput>

            <S.SeparateDiv>
              <S.FormInput>
                <S.Label>
                  Convênio
                </S.Label>
                <S.Select {...register("agreement_id")}>
                  <option value="" disabled selected hidden>
                    Selecione
                  </option>
                  {material.map((val) => {
                    return <option value={val.id}>{val.agreement}</option>;
                  })}
                </S.Select>
              </S.FormInput>

              <S.FormInput>
                <S.Label>Número</S.Label>
                <S.Input type="text" placeholder="Número do convênio" />
              </S.FormInput>
            </S.SeparateDiv>
          </S.Container>
        )}

        <CreateAdress
          isOpenModalAdress={isOpenModal("createAddress")}
          setModalClose={() => {
            toggleModalVisibility("createAddress");
          }}
          idCustom={selectedUrlId}
        />

        {
          addressId &&
          <UpdateAdress
            isOpenModalAdress={isOpenModal("updateAddress")}
            setModalClose={() => {
              toggleModalVisibility("updateAddress");
              setModalClose();
            }}
            selectedUrlId={addressId}
            idCustom={selectedUrlId}
            refreshFrames={updateList}
          />
        }
      </LayoutModal>
    );
  }
  return null;
}
